jQuery( function( $ ) {
	$( '.block-separator.next-section' ).on( 'click', function() {
		const $section = $( this ).parent().next( 'section' );
		$( 'body, html' ).animate( {
			scrollTop: $section.offset().top,
		}, 1000 );
	} );

	$( '.block-separator.scroll-to-top' ).on( 'click', function() {
		$( 'body, html' ).animate( {
			scrollTop: 0,
		}, 1000 );
	} );

	$( '.block-separator.scroll-to-id' ).on( 'click', function() {
		const $section = $( '#' + $( this ).data( 'target' ) );
		$( 'body, html' ).animate( {
			scrollTop: $section.offset().top,
		}, 1000 );
	} );
} );
